/* -------------------------------------------------------------------------- */
/*                                Dependencies                                */
/* -------------------------------------------------------------------------- */
import { useMutation } from '@tanstack/react-query';
import { apiClient } from '@lib/api-client';
import { queryClient } from '@lib/react-query';
import { notifications } from '@mantine/notifications';

// I18n
import { useTranslation } from 'react-i18next';

// Types
import { IApiError } from '@global-types/index';
import { TBodyApi } from 'shared/types';
import { TApiResponse } from '../types';

/* -------------------------------------------------------------------------- */
/*                                     Api                                    */
/* -------------------------------------------------------------------------- */
export const addMeasurabilityProject = (
	data: TBodyApi
): Promise<{
	response: TApiResponse;
}> => {
	return apiClient.post('/measurabilities', data);
};

export const useAddMeasurabilityProject = (
	page: number,
	size: number
) => {
	const { t } = useTranslation();
	const {
		mutate,
		isPending: isLoading,
		isSuccess,
	} = useMutation({
		mutationFn: addMeasurabilityProject,

		onSuccess: async () => {
			notifications.show({
				title: t('global.success'),
				message: t(
					'measurabilities.notifications.measurabilitiesSuccessfullyAdded'
				),
				color: 'success',
			});
			queryClient.invalidateQueries({
				queryKey: [
					'measurability-projects',
					{ page: page, size: size },
				],
			});
		},
		onError: (error: IApiError) => {
			notifications.show({
				title: t('global.error'),
				message: t(`api.${error.type}`),
				color: 'error',
			});
		},
	});

	return { mutate, isLoading, isSuccess };
};
